module.exports = __webpack_public_path__ + "static/media/transform.92b41084.jpg";